// extracted by mini-css-extract-plugin
export default {"popoverTitleTip":"popoverTitleTip___Hixqj","resourceDot":"resourceDot___kmTNR","objectDot":"objectDot___WY5e9","exhibitDot":"exhibitDot___ANKan"};